import { render, staticRenderFns } from "./MolliePaymentComplete.vue?vue&type=template&id=2e72669c&scoped=true&"
import script from "./MolliePaymentComplete.vue?vue&type=script&lang=js&"
export * from "./MolliePaymentComplete.vue?vue&type=script&lang=js&"
import style0 from "./MolliePaymentComplete.vue?vue&type=style&index=0&id=2e72669c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72669c",
  null
  
)

export default component.exports